import { grey } from "@mui/material/colors";

const styles = {
  closeButton: {
    color: grey[600],
    fontSize: 14,
    position: "absolute",
    top: 10,
    right: 10,
  },
};

export default styles;
